import { BorderBox } from "@/components/atoms/BorderBox";
import { QuestionFieldOptionsChangeProps } from ".";
import { OldNewValueChange } from "../OldNewValueChange";
import { ListTodo } from "lucide-react";

export function QuestionFieldOptionsChange({ context }: QuestionFieldOptionsChangeProps) {
    return (
        <BorderBox size={"sm"} className="flex flex-col items-start" >
            <h4 className="font-semibold flex gap-1 items-center"><ListTodo size="16"/>Question field properties will change</h4>
            <div className="flex flex-col w-full gap-2">
                {context.modifiedOptions && context.modifiedOptions.length > 0 && context.modifiedOptions.map((modification) => (
                    <OldNewValueChange
                        key={modification.option}
                        label={`Option "${modification.option}" will change`}
                        oldLabel="From instance"
                        oldValue={context.instanceFieldOptions ? context.instanceFieldOptions[modification.option as keyof typeof context.instanceFieldOptions] as string : "ERROR"}
                        newLabel="To template"
                        newValue={context.templateFieldOptions ? context.templateFieldOptions[modification.option as keyof typeof context.templateFieldOptions] as string : "ERROR"}
                        valueName="field option"
                    />
                ))}
            </div>
        </BorderBox>
    )
}